<template>

                    <v-row 
                    align="center"
                    justify="center"
                    class="full-screen2"
                    >
                    
                        <v-col cols="12" class="pb-0 ml-0">
                        
                        <v-row justify="center">
                          <v-col cols="10" lg="2" md="2" >
                              <v-img :src="logoSplash" width="300" height="100" contain></v-img>
                          </v-col>
                        </v-row>
                        <v-row justify="center">
                          <v-col cols="10" lg="2" md="2">
                              <v-img :src="loaderSplash"  aspect-ratio="1" cover></v-img>
                          </v-col>
                        </v-row>
                        <span class="display-1">ЗАГРУЗКА</span>  
                                
                        </v-col>
                    </v-row>


</template>
<script>
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default {
  name: 'Splash',
  data () {
    return {
    logoSplash: require('@/assets/logo-gagarin.svg'),
    loaderSplash: require('@/assets/loader-dots.gif'),
      
    }
  },
    computed: {
    isDebug:{
      get() {
        return this.$store.state.app.isDebug;
      },
    },

    },
    methods:{

    },
}
</script>
<style  scoped>
.full-screen2{
  width: 100%;
  height: 100vh;
  position: absolute;
  top:0;
  left: 0;
  z-index: 1500;
  background-color: #fff;
}

</style>